module.exports = __webpack_public_path__ + "static/media/trailer-3.2b41ed1d.png";